import { CS_00031, CS_00058 } from "../../../utils/errorCodes";
import {
  INVEST_CHECKOUT,
  INVEST_CHECKOUT_SUCCESS,
  INVEST_CHECKOUT_FAILED,
  CLEAR_INVEST_CHECKOUT_LOADING,
  CLEAR_INVEST_CHECKOUT_ERROR,
} from "./constant";

const initialState = {
  investCheckoutRes: {},
  investCheckoutError: false,
  investCheckoutLoading: false,
  showAccountVerificationError: false,
  messageInvestCheckout: "",
  fundResult: {},
};

export default function investCheckoutReducer(
  state = initialState,
  { type, payload }
) {
  switch (type) {
    case INVEST_CHECKOUT:
      return {
        ...state,
        investCheckoutLoading: true,
        investCheckoutError: false,
        showAccountVerificationError: false,
      };
    case INVEST_CHECKOUT_SUCCESS:
      return {
        ...state,
        investCheckoutRes: payload,
        investCheckoutLoading: true,
        showAccountVerificationError: false,
      };
    case INVEST_CHECKOUT_FAILED:
      // should not show generic error prompt if the error code is like below
      // for mpretire checkout
      if (payload.errorCode === CS_00058)
        return {
          ...state,
          investCheckoutLoading: false,
          investCheckoutError: false,
          showAccountVerificationError: false,
        };

      return {
        ...state,
        investCheckoutError: true,
        messageInvestCheckout: payload.message,
        investCheckoutLoading: false,
        showAccountVerificationError: payload.errorCode === CS_00031,
      };
    case CLEAR_INVEST_CHECKOUT_LOADING:
      return {
        ...state,
        investCheckoutLoading: false,
      };
    case CLEAR_INVEST_CHECKOUT_ERROR:
      return {
        ...state,
        investCheckoutError: false,
        showAccountVerificationError: false,
      };
    default:
      return state;
  }
}
